/// <amd-module name="Wit/BacklogsHub/Common/Utils" />

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLayoutManager, WrappedComponent } from "VSS/Platform/Layout";
import { IBacklogSettingsPanelProps } from "Wit/BacklogsHub/BacklogSettings/Components/BacklogSettingsPanel.Props";
import * as React from "react";

export function renderBacklogSettingsPanel(pageContext: IVssPageContext, props: Omit<IBacklogSettingsPanelProps, "onDismiss">): void {
    pageContext.getService<IVssLayoutManager>("IVssLayoutManager").renderCallout(onDismiss => (
        <WrappedComponent<IBacklogSettingsPanelProps>
            dependencies={["ms.vss-work-web.team-settings-panel"]}
            wrappedType="ms.vss-work-web.backlog-settings-panel-component"
            wrappedProps={{
                ...props,
                onDismiss
            }}
        />
    ));
}
